import { StatusCodes } from '@e3dc-react/shell/Libs'
import { ApiResult, AuthFetchError, AuthFetchWithResponse } from '@e3dc-react/shell/Types'
import { throwApiError } from 'src/Libs/api'
import { WallboxIdentityStatusDto } from '../types'

/**
 * Fetch wallbox identity status from EMC hardware device.
 * @param emcHardwareDeviceId  EMC Hardware Device ID
 * @param authFetch  AuthFetch function
 * @returns WallboxIdentityStatusDto or null if not found
 */
export const getWallboxesIdentityStatus = async (
  emcHardwareDeviceId: string,
  authFetch: AuthFetchWithResponse
): Promise<ApiResult<WallboxIdentityStatusDto | null>> => {
  try {
    const response = await authFetch<WallboxIdentityStatusDto>({
      path: `wallboxes/${emcHardwareDeviceId}/identification`,
    })

    if (response.status !== StatusCodes.OK) {
      return new ApiResult<null, Error | AuthFetchError>(null)
    }

    return new ApiResult<WallboxIdentityStatusDto>(response.data)
  } catch (error) {
    return throwApiError(error, 'Failed to get wallbox identity status:')
  }
}

/**
 * Update wallbox identity status (macAddress).
 * @param emcHardwareDeviceId  EMC Hardware Device ID
 * @param wallboxMacAddress  Wallbox MAC Address
 * @param authFetch  AuthFetch function
 * @returns null
 */
export const updateWallboxIdentityStatus = async (
  emcHardwareDeviceId: string,
  wallboxMacAddress: string,
  authFetch: AuthFetchWithResponse
): Promise<ApiResult<null>> => {
  try {
    const response = await authFetch({
      path: `wallboxes/${emcHardwareDeviceId}/identification`,
      method: 'PUT',
      payload: {
        macAddress: wallboxMacAddress,
      },
    })

    if (response.status !== StatusCodes.OK) {
      return new ApiResult<null, Error | AuthFetchError>(null)
    }

    return new ApiResult<null>(null)
  } catch (error) {
    return throwApiError(error, 'Failed to update wallbox identity status:')
  }
}
